import { render, staticRenderFns } from "./Secret1.vue?vue&type=template&id=ff5267f6&scoped=true&"
import script from "./Secret1.vue?vue&type=script&lang=js&"
export * from "./Secret1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5267f6",
  null
  
)

export default component.exports